module.exports = __webpack_public_path__ + "static/media/icon-character__vladimir-putin.a3548671.svg";